import { Trans } from '@lingui/macro';
import { getRedirectUri } from '../../util/ChangeLanguage';
import React from 'react';
import AuthLayout from '../layout';

export default function SignupSuccess() {
  const redirectToHome = () => {
    window.location.href = getRedirectUri();
  };
  return (
    <AuthLayout>
      <div className="text-white">
        <div
          className="text-luat_HN_primary"
          style={{ fontWeight: 'bold', fontSize: '30px', textAlign: 'center' }}
        >
          <Trans>Đăng ký thành công</Trans>
        </div>
        <div className="w-[400px] text-center text-black my-[24px]">
          <Trans>
            Vui lòng kiểm tra email để kích hoạt tài khoản tham gia và trải
            nghiệm
          </Trans>
          <span className="text-luat_HN_primary">&nbsp;HBA Connections</span>
        </div>
        <div style={{ display: 'flex', justifyContent: 'center' }}>
          <button
            onClick={() => redirectToHome()}
            className="rounded py-2 px-5 bg-luat_HN_primary hover:bg-luat_HN_primary_hover text-white transition duration-300"
          >
            <Trans>Quay lại HBA Connections</Trans>
          </button>
        </div>
      </div>
    </AuthLayout>
  );
}
